// In Next.js, this file would be called: app/providers.jsx
import React, { useState } from 'react'
import PropTypes from 'prop-types'
// We can not useState or useRef in a server component, which is why we are
// extracting this part out into it's own file with 'use client' on top
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { showToaster } from '../toaster/helper'
// import { showToaster } from 'shared/components/toaster/helper'

function QueryProvider({ children }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          mutations: {
            onError: (e) => {
              showToaster({ msg: e?.sMessage || e?.message, eType: 'e' })
            }
          },
          queries: {
            retry: false,
            refetchOnWindowFocus: false,
            select: (d) => d?.data || d,
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 60 * 1000
          }
        }
      })
  )
  return <QueryClientProvider client={client}>{children(client)}</QueryClientProvider>
}
QueryProvider.propTypes = {
  children: PropTypes.func.isRequired
}
export default QueryProvider
